import React, { Component } from 'react';
import Vas from '../Vas';
//import '../css/Tariffing.css';
import { LinkButton } from 'component-lib';

class ErrorLogin  extends Component {

    //#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        return (<div className="TariffingContainer" >
          <div 
            className={"tariffingform"} 
            style={{ textAlign:'left' }}>
            <br />
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Titles["Error"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td style={{ fontSize:'14px'}}>{Vas.Resources.Labels["ExpiredToken"]}</td>  
                </tr>
                <tr>
                  <td style={{ fontSize:'14px' }}>
                    <LinkButton 
                      Text={Vas.Resources.Menus["Login"]} 
                      Id={"LinkLogin"} 
                      OnClick={()=>{Vas.GetView("Login",null,false);}} />
                  </td>
                </tr>
              </tbody>
            </table> 
            </div>
        </div>);
    }
}
export default ErrorLogin;
